import { Button } from '../../../atoms/buttons/Button.tsx';
import { Modal, ModalBody, ModalFooter, ModalHeader } from '../../modal/index.ts';
import { Spacer } from '../../spacer/Spacer.tsx';

type Props = {
  title: React.ReactNode;
  children: React.ReactNode;
  onCancel: () => void;
  onAccept: () => void;
  isOpen?: boolean;
  disableAccept?: boolean;
  acceptButtonText?: string;
  cancelButtonText?: string;
  /** Whether to use FocusScope when determining the element to focus after close. */
  shouldRestoreFocusViaFocusScope?: boolean;
};

/**
 * This is a convenience component which constructs a modal for the common
 * case of asking the user an Cancel/OK question.
 */
export function ConfirmDialog({
  title,
  children,
  onCancel,
  onAccept,
  disableAccept,
  isOpen = true,
  acceptButtonText = 'OK',
  cancelButtonText = 'Cancel',
  shouldRestoreFocusViaFocusScope,
}: Props) {
  return (
    <Modal isOpen={isOpen} onClose={onCancel} shouldRestoreFocusViaFocusScope={shouldRestoreFocusViaFocusScope}>
      <ModalHeader>{title}</ModalHeader>
      <ModalBody>{children}</ModalBody>
      <ModalFooter>
        <Spacer>
          <Button variant="link" onClick={onCancel}>
            {cancelButtonText}
          </Button>
          <Button onClick={onAccept} disabled={disableAccept}>
            {acceptButtonText}
          </Button>
        </Spacer>
      </ModalFooter>
    </Modal>
  );
}
